import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableVirtuoso } from 'react-virtuoso';
import Chance from 'chance';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Table": Table, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableContainer": TableContainer, "@mui/material/TableHead": TableHead, "@mui/material/TableRow": TableRow, "@mui/material/Paper": Paper, "react-virtuoso": { TableVirtuoso }, chance: Chance } } });
export default ClientProvider;
